import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import styles from './styles.module.css'

export const EditableField = ({
  label,
  displayValue,
  isEditing,
  onEdit,
  onCancel,
  fillHeight,
  showActions = true,
  children
}) => {
  if (isEditing) {
    return (
      <div className={styles.editModeWrapper}>
        <div className={styles.editModeContent}>{children}</div>
        {showActions ? (
          <button onClick={onCancel} title='Cancel editing' className={styles.editCancelBtn}>
            ✕
          </button>
        ) : null}
      </div>
    )
  }

  return (
    <div className={fillHeight ? styles.viewModeWrapperFill : styles.viewModeWrapper}>
      <div className={styles.viewModeContent}>
        <div className={styles.fieldLabel}>{label}</div>
        <div className={styles.fieldValue}>
          {displayValue || <span className={styles.fieldValueEmpty}>—</span>}
        </div>
      </div>
      {showActions ? (
        <button onClick={onEdit} title={`Edit ${label}`} className={styles.editBtn}>
          <EditIcon sx={{ color: '#181436', fontSize: 18 }} />
        </button>
      ) : null}
    </div>
  )
}
